import { useState, useEffect, useRef } from "react";

export function useDebounced<T>(value: T, delay: number, onDebounce?: (value: T, previousValue: T) => void): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);
  const previousValueRef = useRef<T>(value);

  useEffect(() => {
    const previousValue = previousValueRef.current;

    const handler = setTimeout(() => {
      setDebouncedValue(value);
      previousValueRef.current = value;
      onDebounce?.(value, previousValue);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
